import {ListaMatriculados as Lista} from 'containers/Admin/ListaMatriculados'

export default function AdminPage() {
  return (
    <Lista />
  );
}
